import { BedroomsContainer } from '../../containers/filters/BedroomsContainer';
import { EFilterType, IOpenableFilter } from '../../types/filters';

export const bedrooms: IOpenableFilter = {
  component: BedroomsContainer,
  type: EFilterType.Openable,
};
